import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { JumpstoryStatistics } from '../models';
import { JumpstoryActions } from '../actions';

export interface State extends EntityState<JumpstoryStatistics> {}

export const adapter: EntityAdapter<JumpstoryStatistics> = createEntityAdapter<
  JumpstoryStatistics
>({
  selectId: (a) => a.id,
  sortComparer: (a, b) => a.accountId.localeCompare(b.accountId),
});

export const initialState: State = adapter.getInitialState();

export const reducer = createReducer(
  initialState,

  on(
    JumpstoryActions.fetchRequest,
    JumpstoryActions.fetchByAccountRequest,
    (state) => adapter.removeAll({ ...state, loading: true }),
  ),

  on(JumpstoryActions.fetchSuccess, (state, { jumpstoryStats }) => {
    return {
      ...adapter.upsertMany(jumpstoryStats, state),
      loading: false,
    };
  }),
  on(JumpstoryActions.fetchFailure, (state) => ({
    ...state,
    loading: false,
  })),
);
